import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import styles from "./related-rail-card.css";

function RelatedRailCard({ candidate }) {
    return (
        <div className={styles.candidateCard}>
            {candidate.image_url && (
                <a href={candidate.url}>
                    <img
                        src={candidate.image_url}
                        alt={candidate.name}
                        className={classnames(styles.candidateImage)}
                    />
                </a>
            )}
            <a href={candidate.url} className={styles.candidateName}>
                {candidate.name}
            </a>
        </div>
    );
}

RelatedRailCard.propTypes = {
    candidate: PropTypes.object.isRequired,
};

export default RelatedRailCard;
